import MenuCustAcct from '../MenuCustAcct';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { AdditionalServicesActionCreator, FrameworkActionCreator, CustomerActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => {
    const specData = state.Specs.specs;
    const apptCust = state.Appointment.ApptCust;
    const apptVeh = state.Appointment.ApptVeh;
    const employeeFlag = state.Customer.Customer.employeeFlag ?? false;

    return {
        specData: specData,
        apptCust: apptCust,
        apptVeh: apptVeh,
        mainPaneViewOrder: state.Framework.mainPaneViewOrder,
        vehicles: state.Vehicles.vehicles,
        selectedVehicle: state.Vehicles.selectedVehicle !== undefined ? state.Vehicles.selectedVehicle : '',
        vehiclePhoto: state.Vehicles.vehiclePhoto,
        vehPhotoList: state.Vehicles.vehPhotoList,
        theme: state.Framework.theme,
        employeeFlag: employeeFlag,
        Itype: state.Framework.ImageServerType,
    };
};

const mapDispatchToProps = {
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    setCustMode: FrameworkActionCreator.acSetCustMode,
    viewVehicles: FrameworkActionCreator.ViewVehicles,
    clearMaintContracts: AdditionalServicesActionCreator.ClearMaintContractData,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MenuCustAcct);